<template>
	<div>
		<div class="section titles wf-section">
			<div class="container titles w-container">
				<h1 class="heading-large">Aktivera ditt konto</h1>
			</div>
		</div>

		<div class="section wf-section">
			<div class="container w-container">
				<div class="w-layout-grid main-grid">
					<div id="w-node-ae74bca1-7a2a-7d20-3579-bd2748f73683-0f8c2979"
						class="gray-wrapper inner-form-medium">
						<div class="form-container">
							<div class="form-wrapper left">
								<div class="full-form w-form">
									<form action="#" @submit.prevent="submit" class="inner-form">
										<div class="inner-input margin-bottom-xsmall">
											<div class="label-form">Skapa ditt lösenord</div>
											<input id="password" type="password" class="text-field dark w-input"
												placeholder="Enter a Password" maxlength="256" name="password"
												required v-model="password" />
										</div>
										<div class="inner-input flex-horizontal margin-bottom-xsmall">
											<input type="submit" value="Activate" data-wait="Please wait..."
												class="button color-red w-button">
										</div>
									</form>
									<div v-if="error" class="error rounded w-form-fail">
										<div>Oops! Something went wrong - {{ error }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
import firebase from 'firebase/app';
import Footer from "@/components/Footer";

export default {
	name: 'Users',
	components: {
		Footer
	},
	data() {
		return {
			password: null,
			actionCode: null,
			error: null
		};
	},
	mounted: function () {
		// Get the one-time code from the query parameter.
		this.actionCode = this.getParameterByName('oobCode');
		if(!this.actionCode){
			this.$router.replace({ name: "login" });
		}
	},
	methods: {
		submit() {
			firebase.auth().verifyPasswordResetCode(this.actionCode).then((email) => {
				const accountEmail = email;
				// console.log("accountEmail"+accountEmail); // eslint-disable-line no-console				
				// Save the new password.
				firebase.auth().confirmPasswordReset(this.actionCode, this.password).then((resp) => {
					firebase
						.auth()
						.signInWithEmailAndPassword(accountEmail, this.password)
						.then(data => {
							this.$router.replace({ name: "Dashboard" });
						})
						.catch(err => {
							this.error = err.message;
						});
				})
					.catch(err => {
						this.error = err.message;
					});
			})
				.catch(err => {
					this.error = err.message;
				});
		},
		getParameterByName(name) {
			if (name !== "" && name !== null && name != undefined) {
				name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
				var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
					results = regex.exec(location.search);
				return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
			} else {
				var arr = location.href.split("/");
				return arr[arr.length - 1];
			}
		}
	}
};
</script>
<style scoped>
.section.titles {
	padding-top: 1vh;
}
.container.titles{
	padding-bottom: 5vh;
}
.gray-wrapper.inner-form-medium {
	padding-top: 3em;
	padding-bottom: 0;
}
@media screen and (max-width: 991px) {
	.container.titles{
		padding-bottom: 1vh;
	}
	.gray-wrapper.inner-form-medium {
		padding-top: 2em;
		padding-bottom: 0;
	}
}
.w-form-fail {
	display: block;
}
</style>
